module.exports = __webpack_public_path__ + "img/ic／6.a4ca8bd8.png";